/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IntegrationsResourceControllerFindAllQueryResponse, IntegrationsResourceControllerFindAllQueryParams, IntegrationsResourceControllerFindAll401, IntegrationsResourceControllerFindAll403 } from "../../models/integrationsController/IntegrationsResourceControllerFindAll";

function getIntegrationsResourceControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/integrations` as const }  
  return res
}

/**
 * @summary List integrations
 * {@link /api/v1/integrations}
 */
export async function integrationsResourceControllerFindAll(params?: IntegrationsResourceControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IntegrationsResourceControllerFindAllQueryResponse, ResponseErrorConfig<IntegrationsResourceControllerFindAll401 | IntegrationsResourceControllerFindAll403>, unknown>({ method : "GET", url : getIntegrationsResourceControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}